import { Injectable, inject } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { Paypal } from '@df/module-paypal/paypal.namespace';
import { TimeoutService } from '@df/ng/timeout.service';

@Injectable({
    providedIn: 'root'
})
export class PaypalPayInThreeService {
    private sdkLoaded = false;
    private request = inject(RequestService);
    private timeoutService = inject(TimeoutService);

    async load() {
        if (!this.sdkLoaded) {
            const sdkUrl = await this.getSDKUrl();

            if (sdkUrl) {
                await this.timeoutService.setTimeout(() => {
                    this.loadSDK(sdkUrl);
                }, 100);
            }
        }
    }

    private async getSDKUrl(): Promise<URL> {
        const result = await this.request.send(undefined, { path: Paypal.EXPRESS_ENDPOINTS.buttonConfig }, undefined, undefined, {
            method: 'GET'
        });
        const sdkUrl = new URL(result.sdkUrl);
        return sdkUrl;
    }

    private async loadSDK(sdkUrl) {
        await this.request.loadScript(sdkUrl);
        this.sdkLoaded = true;
    }
}
